import type { Store } from './store';

import { DefaultPageState } from '../pages/default/defaultPageState';
import { LoginPageState } from '../pages/auth/login/loginPageState';
import { RegisterPageState } from '../pages/auth/register/registerPageState';
import { OnboardPageState } from '../pages/auth/onboard/onboardPageState';
import { ForgotPasswordPageState } from '../pages/auth/forgotPassword/forgotPasswordPageState';
import { OAuthCallbackPageState } from '../pages/oauth/oauthCallbackPageState';
import { OAuthLogoutPageState } from '../pages/oauth/oauthLogoutPageState';
import { UnsubscribePageState } from '../pages/account/subscriptionsPageState';
import { UserSplashPageState } from '../pages/userSplashPage/userSplashPageState';
import { UserPlayerPageState } from '../pages/userPlayerPage/userPlayerPageState';
import { UserDashboardPageState } from '../pages/userDashboardPage/userDashboardPageState';
import { TrainerVideoPageState } from '../pages/trainerVideoPage/trainerVideoPageState';
import { TrainerDashboardPageState } from '../pages/trainerDashboardPage/trainerDashboardPageState';
import { TeamDashboardPageState } from '../pages/teamDashboardPage/teamDashboardPageState';
import { TeamSettingsPageState } from '../pages/teamSettingsPage/teamSettingsPageState';
import { LiveStreamQueuePageState } from '../pages/liveStreamQueuePage/liveStreamQueuePageState';
import { AdminTeamsPageState } from '../pages/adminTeamsPage/adminTeamsPageState';
import { UploadPageState } from '../pages/uploadPage/uploadPageState';
import { DocumentUploadPageState } from '../pages/documentUploadPage/documentUploadPageState';
import { DocumentPageState } from '../pages/documentPage/documentPageState';
import { TrainerDocumentPageState } from '../pages/trainerDocumentPage/trainerDocumentPageState';
import { BookmarksPageState } from '../pages/bookmarksPage/bookmarksPageState';
import { SearchResultsState } from '../pages/searchResultsPage/searchResultsState';
import { CliprGptSearchResultPageState } from '../pages/cliprGptSearchResultPage/cliprGptSearchResultPageState';
import { CreateTeamPageState } from '../pages/createTeamPage/createTeamPageState';
import { ProfilePageState } from '../pages/account/profilePageState';
import { AnalyticsPageState } from '../pages/analyticsPage/analyticsPageState';
import { TrainPageState } from '../pages/trainPage/trainPageState';
import { AgencySignupPageState } from '../pages/agencySignupPage/agencySignupPageState';
import { AgencyDashboardPageState } from '../pages/agencyDashboardPage/agencyDashboardPageState';
import { AdminAgenciesPageState } from '../pages/adminAgenciesPage/adminAgenciesPageState';
import { AdminAgencyPageState } from '../pages/adminAgencyPage/adminAgencyPageState';
import { CustodyAuditPageState } from '../pages/custodyAuditPage/custodyAuditPageState';

export function createPageStores(store: Store) {
  return {
    defaultPage: new DefaultPageState(store),
    loginPage: new LoginPageState(store),
    registerPage: new RegisterPageState(store),
    onboardPage: new OnboardPageState(store),
    forgotPasswordPage: new ForgotPasswordPageState(store),
    oauthCallbackPage: new OAuthCallbackPageState(store),
    oauthLogoutPage: new OAuthLogoutPageState(store),
    unsubscribePage: new UnsubscribePageState(store),
    userSplashPage: new UserSplashPageState(store),
    userPlayerPage: new UserPlayerPageState(store),
    userDashboardPage: new UserDashboardPageState(store),
    trainerVideoPage: new TrainerVideoPageState(store),
    trainerDashboardPage: new TrainerDashboardPageState(store),
    teamDashboardPage: new TeamDashboardPageState(store),
    teamSettingsPage: new TeamSettingsPageState(store),
    liveStreamQueuePage: new LiveStreamQueuePageState(store),
    adminTeamsPage: new AdminTeamsPageState(store),
    uploadPage: new UploadPageState(store),
    documentUploadPage: new DocumentUploadPageState(store),
    documentPage: new DocumentPageState(store),
    trainerDocumentPage: new TrainerDocumentPageState(store),
    bookmarksPage: new BookmarksPageState(store),
    searchResultsPage: new SearchResultsState(store),
    cliprGptSearchResultPageState: new CliprGptSearchResultPageState(store),
    createTeamPage: new CreateTeamPageState(store),
    profilePage: new ProfilePageState(store),
    analyticsPage: new AnalyticsPageState(store),
    trainPage: new TrainPageState(store),
    agencySignupPage: new AgencySignupPageState(store),
    agencyDashboardPage: new AgencyDashboardPageState(store),
    adminAgenciesPage: new AdminAgenciesPageState(store),
    adminAgencyPage: new AdminAgencyPageState(store),
    custodyAuditPage: new CustodyAuditPageState(store),
  };
}

export type PageStores = ReturnType<typeof createPageStores>;
